import React, { useEffect, useState } from "react";
import { BannerProps } from "./banner.props";
import "./banner.scss";
import FaIcon from "../fa-icon/fa-icon";
import IconLibraryEnum from "../../enums/icon-library.enum";
import BackgroundImage1 from "../../assets/banner/background1.svg";
import BackgroundImage2 from "../../assets/banner/background2.svg";

const Banner = (props: BannerProps) => {
  const { bannerTitle, buttonTitle, icon, onClick } = props;
  const [backgroundImageIndex, setBackgroundImageIndex] = useState(0);
  const backgroundImages = [BackgroundImage1, BackgroundImage2];

  useEffect(() => {
    const timeout = setTimeout(() => {
      setBackgroundImageIndex(1);
    }, 800);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <header
      style={{ backgroundImage: `url(${backgroundImages[backgroundImageIndex]})` }}
      className="banner"
      aria-label={`${bannerTitle}`}
    >
      <span className="banner-content">
        <FaIcon className="banner-icon" icon={icon} library={IconLibraryEnum.KIT} aria-hidden="true" />
        <span className="separator" aria-hidden="true">
          |
        </span>
        <span className="banner-title" id="banner-title">
          {bannerTitle}
        </span>
      </span>
      <button
        className="banner-button"
        onClick={() => onClick()}
        aria-label={buttonTitle}
        aria-describedby="banner-title"
        tabIndex={0}
      >
        {buttonTitle}
      </button>
    </header>
  );
};

export default Banner;
